module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_04.9658adb8.svg";